<template>
  <el-popover
    placement="bottom"
    width="210"
    trigger="click"
    popper-class="patient-poper"
    v-model="visible"
  >
    <div>
      <el-input
        v-model="keywords"
        size="mini"
        class="search-input"
        placeholder="search"
      ></el-input>
      <img
        class="search-icon"
        src="../assets/search-list.svg"
        @click="search"
      />
      <div class="patient-item-wrapper" v-if="products.length">
        <div
          class="patient-item"
          v-for="(product, index) in products"
          :key="index"
          @click="selectProduct(product)"
        >
          <div>
            <img
              class="circle-img mr-20"
              :src="product.avatarUrl"
              v-if="product.avatarUrl"
            />
            <div v-else class="mr-20 grey-circle v-h-center">
              <img src="../assets/picture_white.svg" />
            </div>
          </div>
          <div>
            <div class="name">
              {{ getManufactureName(product.manufacturerID) }}
            </div>
            <div class="desc">
              <div>{{ product.productNumber }}</div>
              <div>({{ product.productName }})</div>
            </div>
          </div>
        </div>
      </div>
      <div class="no-data text-center" v-else></div>
    </div>
    <div class="patient-input-wrapper inline-block" slot="reference">
      <div class="patient-input" prop="patient">
        <img
          class="circle-img mr-20"
          :src="product.avatarUrl"
          v-if="product.avatarUrl"
        />
        <div v-else class="mr-20 white-circle v-h-center">
          <img src="../assets/picture_grey.svg" />
        </div>
        <div>
          <div class="name">
            {{ getManufactureName(product.manufacturerID) }}
          </div>
          <div class="desc">
            <div>{{ product.productNumber }}</div>
            <div>({{ product.productName }})</div>
          </div>
        </div>
        <img
          class="arrow"
          :class="visible ? 'rotate-180' : ''"
          src="../assets/arrow-down.svg"
        />
      </div>
    </div>
  </el-popover>
</template>

<script>
import ApiService from '@/services/CommonApiService.js'
export default {
  data() {
    return {
      visible: false,
      keywords: '',
      product: this.$store.state.product.selectedProduct,
      products: this.$store.state.product.products,
      manufacturers: [],
      keywordsTimer: ''
    }
  },
  mounted() {
    this.getManufactures()
    this.$store.dispatch('product/fetchProduct').then(() => {
      this.products = this.$store.state.product.products
      this.product = this.$store.state.product.selectedProduct
    })
  },
  watch: {
    keywords() {
      if (this.keywordsTimer) {
        clearTimeout(this.keywordsTimer)
      }
      this.keywordsTimer = setTimeout(this.search, 500)
    }
  },
  methods: {
    getManufactures() {
      ApiService.GetManufactures().then(response => {
        this.manufacturers = response.data.data
      })
    },
    getManufactureName(id) {
      let name
      this.manufacturers.forEach(item => {
        if (item.id === id) {
          name = item.name
        }
      })
      return name
    },
    search() {
      return ApiService.GetProducts()
        .then(response => {
          this.products = response.data.data
          if (this.keywords) {
            this.products = this.products.filter(item => {
              return (
                item.productName
                  .toLowerCase()
                  .indexOf(this.keywords.toLowerCase()) > -1 ||
                item.productNumber
                  .toLowerCase()
                  .indexOf(this.keywords.toLowerCase()) > -1
              )
            })
          }
        })
        .catch(() => {})
    },
    selectProduct(item) {
      this.product = item
      this.visible = false
      this.$store.commit('product/SET_SELECTED_PRODUCT', this.product)
    }
  },
  beforeDestroy() {
    clearInterval(this.keywordsTimer)
  }
}
</script>

<style lang="scss" scoped>
.no-data {
  height: 80px;
}
</style>
